module.exports = __webpack_public_path__ + "static/media/degree.2a910d73.PNG";